<div class="generic-table-container">
  <!-- Loading State -->
  @if (loading) {
  <div class="loading-state">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading...</p>
  </div>
  }

  <!-- Table -->
  @if (!loading && dataSource.data.length > 0) {
  <table mat-table [dataSource]="dataSource" matSort [matSortDisabled]="!showSort" class="modern-table" [trackBy]="trackByFn">
    <!-- Dynamic Columns -->
    @for (column of columns; track column.key) {
    <ng-container [matColumnDef]="column.key">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="column.sortable === false" [style.width]="column.width">
        {{ column.header }}
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        @if (column.template) {
        <ng-container *ngTemplateOutlet="column.template; context: { $implicit: element, value: element[column.key], index: getGlobalIndex(i) }"></ng-container>
        } @else {
        {{ element[column.key] }}
        }
      </td>
    </ng-container>
    }

    <!-- Actions Column with 3-dots Menu -->
    @if (showActions) {
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef [style.width]="actionColumnWidth">Actions</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="actionMenu" (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
        </button>
         <mat-menu #actionMenu="matMenu">
          @if (showViewAction) {
          <button mat-menu-item (click)="onView(element, $event)">
            <mat-icon>visibility</mat-icon>
            <span>View</span>
          </button>
          }
          <button mat-menu-item (click)="onEdit(element, $event)">
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
          </button>
          <button mat-menu-item (click)="onDelete(element, $event)">
            <mat-icon color="warn">delete</mat-icon>
            <span>Delete</span>
          </button>
         
          
        </mat-menu>
      </td>
    </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns;"
      (click)="onRowClick(row)"
      [class.clickable]="rowClick.observed"
    ></tr>
  </table>

  <!-- Paginator (Used if no external paginator provided) -->
  @if (!externalPaginator && showPaginator) {
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons></mat-paginator>
  }
  }

  <!-- Empty State -->
  @if (!loading && dataSource.data.length === 0) {
  <div class="empty-state">
    <mat-icon>{{ emptyStateIcon }}</mat-icon>
    <h3>{{ emptyStateTitle }}</h3>
    <p>{{ emptyStateMessage }}</p>
    <ng-content select="[emptyStateAction]"></ng-content>
  </div>
  }
</div>
